import React from "react";
import { ShieldAlert, X } from "lucide-react";

const VerificationModal = ({ isOpen, onClose, title, message, buttonText }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop dengan Blur Mewah */}
      <div 
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-md transition-opacity animate-in fade-in duration-300" 
        onClick={onClose}
      ></div>
      
      {/* Konten Modal */}
      <div className="relative bg-white dark:bg-slate-900 w-full max-w-sm p-8 rounded-[3rem] shadow-[0_20px_50px_rgba(0,0,0,0.3)] border border-white/20 transform transition-all animate-in zoom-in-95 duration-300">
        
        {/* Tombol Close */}
        <button 
          onClick={onClose} 
          className="absolute right-8 top-8 text-slate-400 hover:text-red-500 transition-colors p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full"
        >
          <X size={18} />
        </button>
        
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Icon Section */}
          <div className="relative">
            <div className="absolute inset-0 bg-red-500 blur-2xl opacity-20 animate-pulse"></div>
            <div className="relative w-20 h-20 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center text-red-600 border border-red-100 dark:border-red-900/30">
              <ShieldAlert size={40} strokeWidth={2.5} />
            </div>
          </div>

          {/* Text Section (Dinamis berdasarkan props) */}
          <div className="space-y-2">
            <h3 className="text-2xl font-black uppercase tracking-tighter text-[#003366] dark:text-white">
              {title || "Verifikasi Gagal"}
            </h3>
            <p className="text-[13px] text-slate-500 dark:text-slate-400 leading-relaxed font-medium">
              {message || 'Silakan selesaikan tantangan keamanan untuk melanjutkan.'}
            </p>
          </div>

          {/* Action Button (Sekarang mendukung prop buttonText) */}
          <button 
            onClick={onClose}
            className="w-full py-5 bg-[#004A8D] hover:bg-[#003566] text-white font-black uppercase text-[12px] tracking-[0.2em] rounded-2xl shadow-xl shadow-blue-900/20 transition-all active:scale-[0.97]"
          >
            {buttonText || "Selesaikan Verifikasi"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;